import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UtilityService } from '../services/utility.service';
import { APP_CONFIG } from '../../core/services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SplunkService {
  ipaddress: any;
  splunkBody: any;

  constructor(
    private http: HttpClient,
    private utilityService: UtilityService
  ) { }

  /**
   * Method to log splunk
   */
  logEventToSplunk(request: any) {
    const httpOptions = this.utilityService.getHttpHeadersSplunk();
    return this.http.post(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.SPLUNK_URL}`, request, httpOptions);
  }
}
